import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContentPromo from '../components/promo/ContentPromo';

function Promo() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <ContentPromo />
      </main>
      <Footer />
    </div>
  );
}

export default Promo;
